<template>
  <div class="help">
    <div class="banner-wrapper">
      <img src="../assets/help/banner.png" alt="" class="banner">
    </div>
    <div class="data-count">
      <ul class="data-ul flex-align-between">
        <li class="data-li">
          <p class="data-li-value">1000+</p>
          <h5 class="data-li-name">共建区域</h5>
        </li>
        <li class="data-li">
          <p class="data-li-value">20000+</p>
          <h5 class="data-li-name">参训人数</h5>
        </li>
        <li class="data-li">
          <p class="data-li-value">3000+</p>
          <h5 class="data-li-name">课程</h5>
        </li>
      </ul>
    </div>
    <div class="help-wrapper">
      <div class="news flex-between">
        <div class="news-carousel">
          <el-carousel indicator-position="outside" :autoplay="false">
            <el-carousel-item v-for="(item,index) in carouselNewsList" :key="index">
              <div class="news-carousel-item csp" @click="$router.push(`/home/news/detail/${item.id}?type=${1}`)">
                <img :src="item.cover" alt="">
                <p>{{item.title}}</p>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="news-main">
          <div class="news-title flex-between">
            <div>
              <span class="tab csp" v-for="(item,index) in ['通知公告','教育资讯']" :key="index"
                :class="{'active-tab':activeTab === index }" @click="toggleTab(index)">
                {{item}}
              </span>
            </div>
            <button class="news-more csp" @click="$router.push(`/home/news?type=${activeTab+2}`)">
              更多<i class="el-icon-arrow-right" style="font-size:12px"></i>
            </button>
          </div>
          <div class="news-list">
            <h6 v-for="(item,index) in noticeAndEduList" :key="index" class="flex-between article-title csp"
              @click="$router.push(`/home/news/detail/${item.id}?type=${activeTab+2}`)">
              <p class="wes">{{item.title}}</p>
              <span class="date">{{dayjs(item.createTime).format('YYYY-MM-DD')}}</span>
            </h6>
          </div>
        </div>
      </div>
      <div class="display-project">
        <h3 class="display-project-title">
          <span>项目展示</span>
        </h3>
        <div class="sort flex-layout">
          <span class="sort-title">地区：</span>
          <ul class="sort-ul">
            <li v-for="item in sortList" :key="item.id" class="sort-li csp"
              :class="{'active':selectedSortId == item.id}" @click="selectedSortId = item.id">
              {{item.name}}
            </li>
          </ul>
        </div>
        <div class="container ">
          <div class="left-container container-item">
            <h5 class="flex-align-between year">2021年 <button class="more csp">更多<i class="el-icon-arrow-right"
                  style="font-size:14px"></i></button> </h5>
            <ul class="project-ul">
              <li v-for="item in projectList" :key="item.id" class="project-li csp">
                <h6 class="project-li-name flex-align-between">{{item.name}}<span
                    class="project-li-time">{{item.time}}</span></h6>
              </li>
            </ul>
          </div>
          <div class="right-container container-item">
            <h5 class="flex-align-between year">2020年<button class="more csp">更多<i class="el-icon-arrow-right"
                  style="font-size:12px"></i></button>
            </h5>
            <ul class="project-ul">
              <li v-for="item in projectList" :key="item.id" class="project-li csp">
                <h6 class="project-li-name flex-align-between">{{item.name}}<span
                    class="project-li-time">{{item.time}}</span></h6>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeTab: 0,
        imgHeight: '500px',
        carouselNewsList: [],
        noticeAndEduList: [],
        selectedSortId: 1,
        sortList: [{
            id: 1,
            name: "全部"
          },
          {
            id: 2,
            name: "示范区"
          },
          {
            id: 3,
            name: "东城区"
          },
          {
            id: 4,
            name: "西城区"
          },
          {
            id: 5,
            name: "朝阳区"
          },
        ],
        projectList: [{
            id: 1,
            name: '和田地区优秀干部教师能力素质培养提升培训',
            time: '2021-10-15——2021-11-06'
          },
          {
            id: 2,
            name: '第十四师教育系统人才培养项目',
            time: '2021-10-15——2021-10-30'
          },
          {
            id: 3,
            name: '十四师中小学青年教师人才培养项目',
            time: '2021-09-15——2021-09-30'
          },
          {
            id: 4,
            name: '教师能力提升项目',
            time: '2021-09-15——2021-09-30'
          },
          {
            id: 5,
            name: '名校联盟双师课堂',
            time: '2020-08-12——2020-11-30'
          }
        ],
      }
    },
    methods: {
      toggleTab(index) {
        this.activeTab = index;
        this.getNewsList(index + 2);
      },
      // 请求头条新闻
      async getNewsList(type) {
        let that = this;
        let params = {
          clazz: type, //轮播图新闻
          isAsc: 'desc',
          pageNum: 1,
          pageSize: 5
        }

        let resData = await Api.Home.GetNewsList(params)
        console.log(resData)
        if (type == 1) this.carouselNewsList = resData.rows.slice(0, 5);
        if (type == 2 || type == 3) this.noticeAndEduList = resData.rows.slice(0, 6);
      },
    },
    mounted() {
      this.getNewsList(1);
      this.getNewsList(2);
    },
  }
</script>

<style scoped lang="less">
  .help {
    padding-bottom: 36px;

    .banner {
      width: 100%;
      display: block;
    }

    .data-count {
      box-shadow: 0px 4px 17px 0px rgba(0, 0, 0, 0.03);
      margin-bottom: 60px;


      .data-ul {
        width: 1200px;
        margin: 0 auto;
        padding: 36px 121px 40px 121px;
        box-sizing: border-box;
        text-align: center;
      }

      .data-li {
        width: calc(100% / 3);

        &:nth-child(2) {
          border-left: 1px solid #e8e8e8;
          border-right: 1px solid #e8e8e8;
        }
      }

      .data-li-value {
        font-size: 42px;
        margin-bottom: 20px;
      }

      .data-li-name {
        font-size: 24px;
        font-weight: 300;
      }
    }

    .help-wrapper {
      width: 1200px;
      margin: 0 auto;
    }

    //通知公告、教育资讯
    .news {
      margin-bottom: 65px;

      // 左侧轮播图
      .news-carousel {
        width: 600px;

        /deep/ .el-carousel__container {
          height: 306px;
        }

        .news-carousel-item {
          height: 100%;

          img {
            width: 100%;
            height: 100%;
          }

          p {
            position: relative;
            z-index: 99;
            margin-top: -68px;
            line-height: 68px;
            padding-left: 11px;
            font-size: 14px;
            color: #fff;
            background-color: rgba(0, 0, 0, .5);
          }
        }
      }

      // 右侧新闻
      .news-main {
        width: 540px;

        .news-title {
          border-bottom: 1px solid #DDDDDD;
          height: 35px;

          .tab {
            font-size: 22px;
            padding: 0 16px;
            color: #999;
          }

          .active-tab {
            color: #508EF9;
            position: relative;

            &::after {
              position: absolute;
              content: " ";
              bottom: -12px;
              left: 50%;
              transform: translateX(-50%);
              width: 89px;
              height: 4px;
              background-color: #508EF9;
            }
          }

          .news-more {
            font-size: 15px;
            color: #999;
          }
        }

        .news-list {
          margin-top: 25px;
        }

        .article-title {
          color: #383838;
          font-size: 16px;
          line-height: 41px;
          padding-left: 2px;

          p {
            max-width: 380px;
          }

          &:hover {
            color: #3370FF;
          }
        }

        .date {
          color: #999;
          font-size: 15px;
        }
      }
    }

    // 项目展示
    .display-project {
      .display-project-title {
        text-align: center;
        padding: 52px 0 97px;
        margin-bottom: 40px;
      }

      .display-project-title>span {
        padding: 52px 12px 97px;
        font-size: 32px;
        color: #383838;
        background-image: url("../assets/common/title-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .display-project-title::after {
        content: ' ';
        position: relative;
        z-index: 2;
        display: block;
        margin: 0 auto;
        width: 518px;
        height: 28px;
        top: 32px;
        background-image: url("../assets/common/title-bottom.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .sort {
        font-size: 16px;
        color: #666;

        .sort-title {
          width: 55px;
        }

        .sort-li {
          display: inline-block;
          padding: 0 15px;

          &.active {
            color: #3370FF;
          }
        }

      }

      .container {
        margin: 58px 0 38px;
      }

      .container-item {
        box-sizing: border-box;
        display: inline-block;
        width: calc(100% / 2);
        line-height: 40px;
        padding-right: 30px;


        &:nth-child(2) {
          padding: 0 0 0 30px;
        }

        .year {
          border-bottom: 1px solid #DDDDDD;
          padding-left: 15px;
          font-size: 27px;
          font-weight: bold;
          color: #383838;
          position: relative;

          &::before {
            content: ' ';
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            width: 3px;
            height: 25px;
            background-color: #3370FF;
          }
        }

        .more {
          font-size: 14px;
          color: #999;
        }

        .project-ul {
          margin-top: 27px;
        }

        .project-li {
          line-height: 1;
          margin-bottom: 29px;
          font-size: 18px;
          color: #383838;

          &:hover {
            color: #3370FF;
          }
        }

        .project-li-time {
          font-size: 15px;
          color: #999;
          text-align: right;
        }

      }
    }

    @media screen and (max-width: 1250px) {
      padding-bottom: 30px;

      .data-count {
        margin-bottom: 40px;

        .data-ul {
          width: 990px;
          padding: 25px 83px 27px 83px;
        }

        .data-li-value {
          font-size: 35px;
          margin-bottom: 17px;
        }

        .data-li-name {
          font-size: 20px;
        }
      }

      .help-wrapper {
        width: 990px;
      }

      //通知公告、教育资讯
      .news {
        margin-bottom: 50px;

        // 左侧轮播图
        .news-carousel {
          width: 495px;

          /deep/ .el-carousel__container {
            height: 252px;
          }

          .news-carousel-item {
            p {
              margin-top: -37px;
              line-height: 37px;
              font-size: 13px;
            }
          }
        }

        // 右侧新闻
        .news-main {
          width: 450px;

          .news-title {
            height: 31px;

            .tab {
              font-size: 18px;
              padding: 0 13px;
            }

            .news-more {
              font-size: 12px;
            }
          }

          .article-title {
            font-size: 15px;
            line-height: 35px;

            p {
              max-width: 360px;
            }
          }

          .date {
            font-size: 12px;
          }
        }
      }

      // 项目展示
      .display-project {
        .display-project-title {
          padding: 43px 0 80px;
          margin-bottom: 33px;
        }

        .display-project-title>span {
          font-size: 28px;
          padding: 43px 5px 80px;
        }

        .display-project-title::after {
          width: 427px;
          height: 23px;
          top: 26px;
        }

        .sort {
          font-size: 13px;

          .sort-title {
            width: 45px;
          }

          .sort-li {
            padding: 0 10px;
          }

        }

        .container {
          margin: 35px 0 30px;
        }

        .container-item {
          line-height: 33px;
          padding-right: 23px;


          &:nth-child(2) {
            padding: 0 0 0 23px;
          }

          .year {
            padding-left: 15px;
            font-size: 22px;

            &::before {
              width: 2px;
              height: 21px;
            }
          }

          .more {
            font-size: 12px;
          }

          .project-ul {
            margin-top: 22px;
          }

          .project-li {
            margin-bottom: 24px;
            font-size: 15px;
          }

          .project-li-time {
            font-size: 12px;
          }

        }
      }

    }
  }
</style>